import { useQuery } from '@tanstack/react-query'
import { listProduct } from 'services/apiProduct'

const useListProducts = (page,size,searchTerm) => {
    
    const {isPending,isSuccess,isError,error,data} = useQuery({
        queryKey:['productList',page,size,searchTerm],
        queryFn: ()=> listProduct(page,size,searchTerm),
        keepPreviousData:true,
        staleTime: 2 * 60 * 60 * 1000
    })

    return{isPending, isSuccess, isError, error, data}
}

export default useListProducts
